import jQuery from "jquery";

// Explicitly set jQuery and $ on window
window.jQuery = jQuery;
window.$ = jQuery;

export default jQuery;
